<template>

    <div>
        <el-row :gutter="10" class="model-select">
            <el-col :span="24">
                Study subject:
                <el-radio-group v-model="active_model">
                    <el-radio-button label="Animal"></el-radio-button>
                    <el-radio-button label="Human"></el-radio-button>
                </el-radio-group>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <!--el-col :span="8">
                <el-input v-model="search_text" placeholder="Type author or article ref-id"></el-input>
            </el-col-->
            <el-col :span="24">
                <el-select v-model="active_author" filterable clearable placeholder="Select author">
                <el-option
                  v-for="(author, index) in authors"
                  :key="index"
                  :label="author"
                  :value="author">
                </el-option>
              </el-select>
              <el-select v-model="active_refid" filterable clearable placeholder="Select ref-id">
                <el-option
                  v-for="refid in refids"
                  :key="refid"
                  :label="refid"
                  :value="refid">
                    <span style="float: right">{{ refid }}</span>
                </el-option>
              </el-select>
              <el-select v-model="active_study_type" filterable clearable placeholder="Filter by study type">
                <el-option
                  v-for="[st, count] in study_types"
                  :key="st"
                  :label="st"
                  :value="st">
                    <span>{{ st }}</span> (<span style="font-style: italic">{{ count }}</span>)
                </el-option>
              </el-select>
              <el-select v-model="active_endpoint" filterable clearable placeholder="Filter by endpoint">
                <el-option
                  v-for="[endpoint, count] in endpoints"
                  :key="endpoint"
                  :label="endpoint"
                  :value="endpoint">
                    <span>{{ endpoint }}</span> (<span style="font-style: italic">{{ count }}</span>)
                </el-option>
              </el-select>
            </el-col>
        </el-row>

        <div class="counter">
            Showing {{ active_records.length }} of {{ records.length }} articles.
            <div style="float: right">
                <el-switch v-model="show_charts" active-text="Show charts" inactive-text="Hide charts"></el-switch>
            </div>
        </div>

        <div class="charts">
            <Heatmap v-if="show_charts" :data="{'endpoint': endpoints, 'study_type': study_types, 'heatmap': endpoint_study_types}"/>
        </div>

        <AnimalTable
                :active_records="active_records"
                :active_endpoint="active_endpoint"
                :active_study_type="active_study_type"
                v-if="active_model_id === 'animal'"/>
        <HumanTable
                :active_records="active_records"
                :active_endpoint="active_endpoint"
                :active_study_type="active_study_type"
                v-if="active_model_id === 'human'"/>
    </div>
</template>

<script>
  import axios from 'axios'
  import AnimalTable from "./AnimalTable";
  import HumanTable from "./HumanTable";
  import Heatmap from "./Heatmap"

  export default {
    name: "BpaTable",
    components: {AnimalTable, HumanTable, Heatmap},
    props: [],
    data: function () {
      return {
        search_text: '',
        records: [],
        active_refid: null,
        active_author: null,
        active_model: 'Human',
        active_endpoint: null,
        active_study_type: null,
        show_charts: false,
      }
    },
    computed: {
      active_records: function() {
        let records = this.records;
        if (this.search_text)
          records = records.filter(record => record.refid.includes(this.search_text) || record.author.toLowerCase().includes(this.search_text.toLowerCase()))
        if (this.active_author)
          records = records.filter(record => record.author === this.active_author)
        if (this.active_refid)
          records = records.filter(record => record.refid == this.active_refid)
        if (this.active_endpoint)
          records = records.filter(record => {
            if ('bpa_st_res_a_endp_' in record.data)
              for (let endpoint of record.data['bpa_st_res_a_endp_'])
                if (endpoint.join(' / ') === this.active_endpoint)
                  return true
            if ('bpa_st_res_h_endp_' in record.data)
              for (let endpoint of record.data['bpa_st_res_h_endp_'])
                if (endpoint.join(' / ') === this.active_endpoint)
                  return true
            return false
          })
        if (this.active_study_type)
          records = records.filter(record => {
            if ('bpa_st_ch_a_st_typ'  in record.data)
              if (record.data['bpa_st_ch_a_st_typ'].includes(this.active_study_type))
                return true
            if ('bpa_st_ch_h_st_typ_sop'  in record.data)
              if (record.data['bpa_st_ch_h_st_typ_sop'].includes(this.active_study_type))
                return true
            return false
          })
        return records
      },
      endpoints: function() {
        let endpoints = {}
        for (let rec of this.active_records) {
          for (let type_key of ['bpa_st_res_a_endp_', 'bpa_st_res_h_endp_'])
            if (type_key in rec.data)
              for (let subrec_arr of rec.data[type_key]) {
                let subrec = subrec_arr.join(" / ")
                if (subrec in endpoints)
                  endpoints[subrec] += 1
                else
                  endpoints[subrec] = 1
              }
        }
        let ret_endpoints = []
        for (let endpoint in endpoints)
          ret_endpoints.push([endpoint, endpoints[endpoint]])
        ret_endpoints.sort((a, b) => a[0].toLowerCase().localeCompare(b[0].toLowerCase()))
        return ret_endpoints
      },
      study_types: function () {
        let study_types = {}
        for (let rec of this.active_records) {
          for (let type_key of ['bpa_st_ch_a_st_typ', 'bpa_st_ch_h_st_typ_sop'])
            if (type_key in rec.data)
              for (let subrec of rec.data[type_key]) {
                if (subrec in study_types)
                  study_types[subrec] += 1
                else
                  study_types[subrec] = 1
              }
        }
        let ret_study_types = []
        for (let st in study_types)
          ret_study_types.push([st, study_types[st]])
        ret_study_types.sort((a, b) => a[0].toLowerCase().localeCompare(b[0].toLowerCase()))
        return ret_study_types
      },
      endpoint_study_types: function () {
        let endpoints = {}
        for (let rec of this.active_records) {
          for (let type_key of ['bpa_st_res_a_endp_', 'bpa_st_res_h_endp_'])
            if (type_key in rec.data)
              for (let subrec_arr of rec.data[type_key]) {
                let subrec = subrec_arr.join(" / ")
                if (!(subrec in endpoints))
                  endpoints[subrec] = {}
                //
                for (let st_key of ['bpa_st_ch_a_st_typ', 'bpa_st_ch_h_st_typ_sop'])
                  if (st_key in rec.data)
                    for (let st_subrec of rec.data[st_key]) {
                      if (st_subrec in endpoints[subrec])
                        endpoints[subrec][st_subrec] += 1
                      else
                        endpoints[subrec][st_subrec] = 1
                    }
              }
        }
        let ret_endpoints = []
        for (let endpoint in endpoints)
          for (let stype in endpoints[endpoint])
            ret_endpoints.push([endpoint, stype, endpoints[endpoint][stype]])
        // ret_endpoints.sort((a, b) => a[0].toLowerCase().localeCompare(b[0].toLowerCase()))
        return ret_endpoints
      },
      refids: function () {
        return this.active_records.map(record => parseInt(record.refid)).sort((a, b) => a - b)
      },
      authors: function () {
        let authors = this.active_records.map(record => record.author)
        authors = [...new Set(authors)]
        authors = authors.sort()
        return authors
      },
      active_model_id: function () {
        return this.active_model.toLowerCase();
      }
    },
    methods: {
      load_data: function() {
        axios.get(`distillersr_export_${this.active_model_id}s.json`)
          .then((response) => {
            this.records = response.data
            // clear out active markers
            this.active_study_type = null
            this.active_endpoint = null
            this.active_author = null
            this.active_refid = null
          }, (error) => {
            console.log('Error fetching data', error)
          })
      },
    },
    watch: {
      active_model: function () {
        this.records = []
        this.active_refid = null
        this.active_author = null
        this.load_data();
      }
    },
    created: function () {
      this.load_data()
    }
  }
</script>

<style lang="scss">
    div.counter {
        color: #777777;
        margin: 0.5rem;
    }

    .record-list-enter-active, .record-list-leave-active {
      transition: all 300ms;
    }
    .record-list-enter, .record-list-leave-to {
      opacity: 0;
      transform: translateX(20%);
    }
    .el-select {
        margin-right: 0.5rem;
    }
    .model-select {
        margin-bottom: 1.5rem;
    }

    div.charts {
        border-top: solid 2px #cccccc;
        padding-top: 1.5rem;
    }
</style>
